(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-player/assets/javascripts/use-player-polling.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-player/assets/javascripts/use-player-polling.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useContext = _React.useContext;
const EngineProviderContext = svs.components.tipsen.engine.EngineProviderContext;
const _svs$components$tipse = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions,
  updatePlaybackState = _svs$components$tipse.updatePlaybackState,
  clearCurrentVideo = _svs$components$tipse.clearCurrentVideo;
const trackEvent = svs.components.analytics.trackEvent;

const POLLING_INTERVAL = 200;
const POLLING_INTERVAL_PAUSED = 600;
const POLLING_INITIALIZATION_DELAY = 1000;

const getPlayerValue = function (playerMethod, videoId) {
  let fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return new Promise(resolve => {
    playerMethod(videoId, result => {
      var _result$value;
      resolve((_result$value = result === null || result === void 0 ? void 0 : result.value) !== null && _result$value !== void 0 ? _result$value : fallback);
    });
  });
};

const usePlayerPolling = (loadedVideo, currentVideo, currentVideoRef, dispatch) => {
  const _useContext = useContext(EngineProviderContext),
    currentEngine = _useContext.currentEngine;
  const _ref = currentEngine || {},
    brandName = _ref.brandName;
  const pollIntervalRef = useRef(null);
  const currentIntervalRef = useRef(POLLING_INTERVAL);
  const durationRef = useRef(0);
  const positionRef = useRef(0);
  const previousUpdateDataRef = useRef(null);
  const _React$useState = React.useState({
      position: 0,
      duration: 0,
      isPlaying: false
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    playerState = _React$useState2[0],
    setPlayerState = _React$useState2[1];

  const clearPolling = useCallback(() => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }
    previousUpdateDataRef.current = null;
  }, []);

  const updatePlayerState = useCallback(async videoId => {
    if (!svs.components.video_player || !videoId || !currentVideoRef.current) {
      return null;
    }
    try {
      const isReady = await getPlayerValue(svs.components.video_player.isReady, videoId, false);
      const updateData = {
        id: videoId,
        isReady
      };
      let isPlaying = false;
      if (isReady) {
        const _await$Promise$all = await Promise.all([getPlayerValue(svs.components.video_player.getPosition, videoId, 0), getPlayerValue(svs.components.video_player.getDuration, videoId, 0), getPlayerValue(svs.components.video_player.isPlaying, videoId, false)]),
          _await$Promise$all2 = _slicedToArray(_await$Promise$all, 3),
          position = _await$Promise$all2[0],
          duration = _await$Promise$all2[1],
          playingState = _await$Promise$all2[2];
        isPlaying = playingState;
        Object.assign(updateData, {
          currentPosition: position,
          duration,
          isPlaying
        });
        setPlayerState({
          position,
          duration,
          isPlaying
        });
      }

      const previousUpdateData = previousUpdateDataRef.current;
      const hasChanged = !previousUpdateData || previousUpdateData.id !== updateData.id || previousUpdateData.isReady !== updateData.isReady || previousUpdateData.currentPosition !== updateData.currentPosition || previousUpdateData.duration !== updateData.duration || previousUpdateData.isPlaying !== updateData.isPlaying;
      if (hasChanged) {
        dispatch(updatePlaybackState(updateData));
        previousUpdateDataRef.current = updateData;

        if (updateData.duration > 0 && updateData.currentPosition >= updateData.duration - 0.5) {
          dispatch(clearCurrentVideo());
        }
      }
      return isPlaying;
    } catch (error) {
      return null;
    }
  }, [dispatch, currentVideoRef]);

  const startPolling = useCallback(videoId => {
    if (!videoId) {
      return;
    }
    clearPolling();
    const poll = async () => {
      const isPlaying = await updatePlayerState(videoId);

      const targetInterval = isPlaying ? POLLING_INTERVAL : POLLING_INTERVAL_PAUSED;

      if (currentIntervalRef.current !== targetInterval) {
        currentIntervalRef.current = targetInterval;
        clearPolling();
        pollIntervalRef.current = setInterval(poll, targetInterval);
      }
    };

    currentIntervalRef.current = POLLING_INTERVAL;
    pollIntervalRef.current = setInterval(poll, POLLING_INTERVAL);
  }, [updatePlayerState, clearPolling]);

  useEffect(() => {
    durationRef.current = playerState.duration;
    positionRef.current = playerState.position;
  }, [playerState.duration, playerState.position]);

  useEffect(() => {
    if (!(loadedVideo !== null && loadedVideo !== void 0 && loadedVideo.videoId) || !currentVideo) {
      return;
    }
    const productLabel = brandName ? brandName.charAt(0).toUpperCase() + brandName.slice(1) : '';
    const videoTitle = (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.description) || (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title);
    trackEvent({
      category: 'Nya tipsen',
      action: 'video start',
      opt_label: "".concat(videoTitle, ". ").concat(productLabel)
    });
    return () => {
      const finalDuration = durationRef.current > 0 ? Math.floor(durationRef.current) : 0;
      const finalPosition = positionRef.current > 0 ? Math.floor(positionRef.current) : 0;
      trackEvent({
        category: 'Nya tipsen',
        action: 'video stop',
        opt_label: "Duration ".concat(finalPosition, " of ").concat(finalDuration, ", ").concat(videoTitle, ". ").concat(productLabel)
      });
    };
  }, [brandName, currentVideo, loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId]);

  useEffect(() => {
    if (!(loadedVideo !== null && loadedVideo !== void 0 && loadedVideo.videoId) || !currentVideo) {
      clearPolling();
      return;
    }

    previousUpdateDataRef.current = null;
    const startPollingTimeout = setTimeout(() => {
      startPolling(loadedVideo.videoId);
    }, POLLING_INITIALIZATION_DELAY);
    return () => {
      clearTimeout(startPollingTimeout);
      clearPolling();
    };
  }, [loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId, currentVideo, startPolling, clearPolling]);

  useEffect(() => () => clearPolling(), [clearPolling]);
  return playerState;
};
setGlobal('svs.components.tipsen.videoAnalysisPlayer.usePlayerPolling', usePlayerPolling);

 })(window);